module.exports = __webpack_public_path__ + "static/img/32.c5765c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITO/32.png
// module id = Ttfm
// module chunks = 1